<form *ngIf="formGroup" [formGroup]="formGroup">
  <div class="row" *ngIf="!(isLogged || additionalRepresentative)">
    <div class="col-12">
      <mat-radio-group
      *ngIf="!hideIdentificationWithoutIDP; else simpleText"

        class="identification-method-radio-group"
        formControlName="identificationMethod"
        (change)="identificationMethodChanges($event)"
      >
        <mat-radio-button [value]="IdentificationMethod.WITH_IDENTITY_PROVIDER">
          <span class="text-wrap" [innerHtml]="
          'patient-consent.identification.with-identification-provider'
            | translate
          "></span>
        </mat-radio-button>
        <br />
        <div *ngIf="formGroup.get('identificationMethod')?.value === IdentificationMethod.WITH_IDENTITY_PROVIDER;">
          <form-identification-provider (beforeLogin)="onLogin()"[filterProviders]="filterProviders"></form-identification-provider>
          <mat-error
            *ngIf="
              formGroup.get('identificationMethod')?.touched &&
              formGroup.hasError('eidAuthRequired')
            "
            translate
          >
          forms.errors.auth-required
          </mat-error>
        </div>
        <mat-radio-button [value]="IdentificationMethod.WITHOUT_IDENTITY_PROVIDER">
          <span class="text-wrap">
            {{ overrideWithoutEidText || 'patient-consent.identification.without-identification-provider' | translate }}
          </span>
        </mat-radio-button>
      </mat-radio-group>

      <ng-template #simpleText>
        <span class="identification-method-radio-group text-wrap" [innerHtml]="
          'patient-consent.identification.with-identification-provider'
            | translate
          "></span>
          <form-identification-provider (beforeLogin)="onLogin()"[filterProviders]="filterProviders"></form-identification-provider>
          <mat-error
            *ngIf="
              formGroup.get('identificationMethod')?.touched &&
              formGroup.hasError('eidAuthRequired')
            "
            translate
          >
          forms.errors.auth-required
          </mat-error>
      </ng-template>

    </div>
  </div>
  <div
    *ngIf="additionalRepresentative || formGroup.get('identificationMethod')?.value === IdentificationMethod.WITHOUT_IDENTITY_PROVIDER;">
    <form-identification-card class="row" [formGroup]="formGroup" [overrideIdentityCardFrontHint]="overrideIdentityCardFrontHint" [overrideIdentityCardBackHint]="overrideIdentityCardBackHint" ></form-identification-card>
  </div>
  
</form>
